/** Energy — equipment electricity /energy/equipmentPower */
export default {
  equipmentPower: {
    filterStatPeriod: 'Period',
    phDateStart: 'Start',
    phDateEnd: 'End',
    filterTenant: 'Tenant',
    phTenant: 'Select tenant',
    filterMeter: 'Meter',
    phMeter: 'Serial or pick meter',
    exportLoading: 'Exporting...',
    exportReport: 'Export',
    loadingText: 'Loading...',
    sectionTitle: 'Meter usage',
    sectionTip: 'Select a meter to view details',
    maxDemandLabel: 'Max demand:',
    collectTimeLabel: 'Recorded:',
    totalFeeLabel: 'Total cost:',
    totalElecLabel: 'Energy:',
    unitKw: 'kW',
    unitYuan: 'CNY',
    unitKwh: 'kWh',
    unitKwLower: 'kW',
    colEquipment: 'Meter',
    colBindInfo: 'Binding',
    colDate: 'Date',
    colDemandRecord: 'Demand',
    colTotalFee: 'Cost (CNY)',
    colEnergyKwh: 'Energy (kWh)',
    colStartEnd: 'Start / end read',
    colTime: 'Time',
    colTotalElecCol: 'Total (kWh)',
    touSharp: 'Sharp',
    touPeak: 'Peak',
    touFlat: 'Flat',
    touValley: 'Valley',
    metricMaxDemand: 'Max demand:',
    metricCollectTime: 'Recorded:',
    metricTotalFee: 'Total cost:',
    metricTotalElec: 'Total:',
    seStart: 'S',
    seEnd: 'E',
    dash: '—',
    emptyNoData: 'No data',
    emptySelectMeter: 'Pick a meter or enter serial to load data',
    serialPrefix: 'Serial',
    bindDedicated: 'Dedicated',
    bindPublic: 'Shared allocation',
    bindFormula: 'Formula',
    bindAc: 'HVAC meter',
    tenantAll: 'All',
    pickerLast7: 'Last 7 days',
    pickerLast15: 'Last 15 days',
    pickerLast30: 'Last 30 days',
    pickerThisMonth: 'This month',
    pickerLastMonth: 'Last month',
    msgTenantListFail: 'Failed to load tenants',
    msgMeterListFail: 'Failed to load meters',
    msgSelectDate: 'Select a date range',
    msgSelectMeter: 'Select a meter',
    msgNoData: 'No rows returned',
    msgFetchFail: 'Failed to load data',
    msgExportEmpty: 'Nothing to export',
    msgExportOk: 'Export completed',
    msgExportFail: 'Export failed',
    msgExportRetry: 'Try again',
    exportFilterLine: 'Period: {start} – {end} | Tenant: {tenant} | Meter: {meter}',
    exportSheetName: 'Meter usage',
    exportFilePrefix: 'meter_usage',
    expColMeterId: 'Meter ID',
    expColMeterName: 'Name',
    expColSerial: 'Serial',
    expColBindType: 'Bind type',
    expColBindId: 'Bind ID',
    expColBindName: 'Bind name',
    expColDate: 'Date',
    expColTotalFee: 'Cost (CNY)',
    expColTotalKwh: 'Energy (kWh)',
    expColKwhSharp: 'Sharp (kWh)',
    expColKwhPeak: 'Peak (kWh)',
    expColKwhFlat: 'Shoulder (kWh)',
    expColKwhValley: 'Valley (kWh)',
    expRowStartRead: 'Start read',
    expRowStopRead: 'End read',
    expSubTime: 'Time',
    expSubTotal: 'Total',
    expSubSharp: 'Sharp',
    expSubPeak: 'Peak',
    expSubFlat: 'Shoulder',
    expSubValley: 'Valley',
    msgNoSerial: 'Missing serial; cannot open meter',
    msgBindNotTenant: 'Not a tenant binding; cannot open tenant',
    msgNoTenantId: 'Missing tenant ID'
  }
}
